import { PlusCircleIcon } from '@heroicons/react/24/outline';
import {
  ActionIcon,
  Flex,
  List,
  ListItem,
  Space,
  Stack,
  Text,
  Title
} from '@mantine/core';
import { useIntl } from 'react-intl';

import { PageLoading } from '@/pages/PageLoading';
import { usePenaltiesPage } from '@/pages/club/onboard/components/stages/penalties/hooks/usePenaltiesPage';
import { translate } from '@/shared/i18n/translate';
import { useCurrencyStore } from '@/shared/store/store';
import {
  LBButton,
  LBCheckbox,
  LBNumberCurrencyInput,
  LBTextInput
} from '@/shared/ui-kit/components';

export const Penalties = () => {
  const {
    state: { isLoading, form, inputValue, isFormValid },
    functions: { onSubmit, setInputValue }
  } = usePenaltiesPage();

  const { profileCurrency } = useCurrencyStore();
  const { formatMessage } = useIntl();

  if (isLoading) return <PageLoading />;

  return (
    <form onSubmit={onSubmit}>
      <Title order={1}>
        {translate('pages.onboarding.club.penalties.title')}
      </Title>
      <Space h={4} />
      <Text>{translate('pages.onboarding.club.penalties.description')}</Text>
      <Space h={24} />
      <LBTextInput
        placeholder={formatMessage({ id: 'form.penalties.placeholder' })}
        value={inputValue}
        rightSection={
          <ActionIcon
            disabled={form.submitting}
            variant='transparent'
            onClick={() => {
              if (!inputValue.length) {
                return;
              }
              form.insertListItem('penalties', { name: inputValue, fine: 0 });
              setInputValue('');
            }}
          >
            <PlusCircleIcon width={18} />
          </ActionIcon>
        }
        onChange={(e) => setInputValue(e.target.value)}
      />
      <Space h={24} />
      <Stack gap={16}>
        {form.getValues().penalties.map((item, index) => (
          <Flex key={item.name} direction='column' gap={8}>
            <LBCheckbox
              defaultChecked
              disabled={form.submitting}
              label={item.name}
              onChange={(e) => {
                if (e.currentTarget.checked) {
                  form.insertListItem('penalties', item);
                }
                form.removeListItem('penalties', index);
              }}
            />
            <Space h={4} />
            <List withPadding listStyleType='none'>
              <ListItem>
                <LBNumberCurrencyInput
                  key={form.key(`penalties.${index}.fine`)}
                  disabled={
                    form.getValues().penalties[index]
                      ? !(
                          item.name ===
                            form.getValues().penalties[index].name ||
                          form.submitting
                        )
                      : false || form.submitting
                  }
                  {...form.getInputProps(`penalties.${index}.fine`)}
                  currencySymbol={profileCurrency}
                  maw={124}
                  placeholder='0'
                />
              </ListItem>
            </List>
          </Flex>
        ))}
      </Stack>
      <Space h={32} />
      <LBButton
        fullWidth
        // disabled={!isFormValid}
        loading={form.submitting}
        type='submit'
      >
        {isFormValid
          ? translate('commons.finish')
          : translate('commons.continue')}
      </LBButton>
    </form>
  );
};
